import ReactOnRails from 'react-on-rails';
import { Provider } from 'react-redux';

import displayName from '../helpers/displayName';

export default function (WrappedComponent) {
  function wrappedInReduxProvider(props) {
    const store = ReactOnRails.getStore('Store');

    return (
      <Provider store={store}>
        <WrappedComponent {...props} />
      </Provider>
    );
  }

  wrappedInReduxProvider.displayName = `wrappedInReduxProvider(${displayName(WrappedComponent)})`;

  return wrappedInReduxProvider;
}
